<template>
    <v-container fluid class="pl-0">
        <!-- Release title -->
        <v-col :alvqa="alvqa + '-release-title'">
            <v-row class="pl-4 headline">
                {{ item.title }}
            </v-row>
        </v-col>

            <v-row>
                <v-col>
                    <v-card elevation="0">
                        <v-card-text>
                            <!-- TITLE -->
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-title'"
                            >{{ $t('lang_PUBLISHING_PROJECTS_CAPTION_TITLE') }}:</div>
                            <div :alvqa="alvqa + '-title'">
                                {{ item.title }}
                            </div>

                            <!-- PRODUCTION TYPE ID -->
                            <span v-if="item.productionTypeId !== null">
                                <div
                                    class="read-only-caption"
                                    :alvqa="alvqa + '-caption-production-type'"
                                >{{ $t('lang_PUBLISHING_RELEASES_CAPTION_PRODUCTION_TYPE') }}:</div>
                                <div :alvqa="alvqa + '-production-type'">
                                    {{ getProductionTypeOption(item.productionTypeId) }}
                                </div>
                            </span>
                            <!-- PRODUCER -->
                            <span v-if="item.producer !== null">
                                <div
                                    class="read-only-caption"
                                    :alvqa="alvqa + '-caption-producer'"
                                >{{ $t('lang_PUBLISHING_RELEASES_CAPTION_PRODUCER') }}:</div>
                                 <div :alvqa="alvqa + '-producer'">
                                 {{ item.producer.gemaName + " (" + item.producer.alvId + ")"}}
                                </div>
                            </span>
                            <!-- NOTE -->
                            <span v-if="item.note !== null && item.note !== ''">
                             <div
                                    class="read-only-caption"
                                    :alvqa="alvqa + '-caption-note'"
                             >{{ $t('lang_PUBLISHING_RELEASES_CAPTION_NOTE') }}:</div>
                                <div :alvqa="alvqa + '-note'">
                                    {{ item.note }}
                                </div>
                            </span>

                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col v-if="showSecondCard">
                    <v-card elevation="0">
                        <v-card-text>
                            <!-- TV-STATION -->
                            <span v-if="item.tvStation !== null && item.tvStation !== ''">
                             <div
                                    class="read-only-caption"
                                    :alvqa="alvqa + '-caption-tv-station'"
                             >{{ $t('lang_PUBLISHING_RELEASES_CAPTION_TV_STATION_NAME') }}:</div>
                                <div :alvqa="alvqa + '-tv-station'">
                                    {{ item.tvStation }}
                                </div>
                            </span>
                            <!-- TAGS -->
                            <span v-if="item.tag !== null && item.tag !== ''">
                             <div
                                    class="read-only-caption"
                                    :alvqa="alvqa + '-caption-tag'"
                             >{{ $t('lang_PUBLISHING_RELEASES_CAPTION_TAGS') }}:</div>
                                <div :alvqa="alvqa + '-tag'">
                                    {{ item.tag }}
                                </div>
                            </span>
                        </v-card-text>
                    </v-card>
                </v-col>

            </v-row>
        <v-row>
        
            <v-col>
                <v-data-table         
                    :headers="sheetsHeaders"
                    :items="listItemsSheets"                    
                    :expanded.sync="expandedItems"
                    show-expand
                    @click:row="expandItemByClick($event)"
                    :header-props="{ sortIcon: '' }"
                    :items-per-page="itemsPerPage"
                    hide-default-footer
                    sort-by="sheetNumber"
                    :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                    class="noMinWidth"
                    id="sheetsList"
                >
                <!-- Sheet Headers -->
                    <template v-for="(header, i) in sheetsHeaders" v-slot:[`header.${header.value}`]>
                        <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                    </template>

                <!-- Sheet Items -->
                    <!-- Expand Icon -->
                    <template v-slot:[`item.data-table-expand`]="{ isExpanded }">
                        <v-icon 
                            v-if="isExpanded"
                            small 
                            class="ma-0 pa-0"
                            color="buttonStandard"
                        >fa-arrow-alt-circle-down</v-icon>
                        <v-icon 
                            v-else
                            small 
                            class="ma-0 pa-0"
                            color="buttonStandard"
                        >fa-arrow-alt-circle-right</v-icon>
                    </template>
                    <template v-slot:[`item.title`]="{ item }">
                        <BaseTooltip>
                            <template v-slot:content>
                                <div 
                                    :alvqa="alvqa + '-sheets-' + item.id + '-text-title'"
                                    class="ellipsis"
                                >{{ item.title }}</div>
                            </template>
                            <template v-slot:text>{{ item.title }}</template>
                        </BaseTooltip>
                    </template>
                    <template v-slot:[`item.composers`]="{ item }">
                        <BaseTooltip>
                            <template v-slot:content>
                                <div 
                                    class="ellipsis"
                                    :alvqa="alvqa + '-sheets-' + item.id + '-text-composers'"
                                >{{ item.composers.join(" / ") }}</div>
                            </template>
                            <template v-slot:text>{{ item.composers.join(" / ") }}</template>
                        </BaseTooltip>
                    </template>
                    <template v-slot:[`item.publishers`]="{ item }">
                        <BaseTooltip>
                            <template v-slot:content>
                                <div 
                                    class="ellipsis"
                                    :alvqa="alvqa + '-sheets-' + item.id + '-text-publishers'"
                                >{{ item.publishers.join(" / ") }}</div>
                            </template>
                            <template v-slot:text>{{ item.publishers.join(" / ") }}</template>
                        </BaseTooltip>
                    </template>
                    <template v-slot:[`item.productionYear`]="{ item }">
                        <div :alvqa="alvqa + '-sheets-' + item.id + '-text-production-year'">
                            {{ item.productionYear}}
                        </div>
                    </template>
                    <template v-slot:[`item.sheetNumber`]="{ item }">
                        <div :alvqa="alvqa + '-sheets-' + item.id + '-text-sheet-number'">
                            {{ item.sheetNumber }}
                        </div>
                    </template>

                    <template v-slot:expanded-item="{ item }">
                        <td
                            colspan="1"
                            style="background-color: var(--v-expandPanelBackground-base);"
                        ></td>
                        <td 
                            class="pl-0"
                            :colspan="sheetsHeaders.length - 1"
                            style="background-color: var(--v-expandPanelBackground-base);"
                        >
                            <v-container fluid class="pl-0 pr-0">
                                <!-- Sheet title -->
                                <v-col :alvqa="alvqa + '-sheet-title'">
                                    <v-row class="pl-4 headline">
                                        {{ item.title }}
                                    </v-row>
                                </v-col>
                                <v-row>
                                    <v-col class="pr-0">
                                        <v-data-table         
                                            :headers="worksHeaders"
                                            hide-default-footer
                                            :items="listItemsWorks(item)"
                                            item-key="index"
                                            :header-props="{ sortIcon: '' }"
                                            :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                                            :items-per-page="itemsPerPage"
                                            class="noMinWidth"
                                            :id="'worksList-' + item.id"
                                        >
                                        <!-- Works Headers -->
                                            <template v-for="(header, i) in worksHeaders" v-slot:[`header.${header.value}`]>
                                                <span :alvqa="header.alvqa + '-' + item.sheetNumber" :key="i">{{ header.text }}</span>
                                            </template>

                                        <!-- Work Items -->
                                            <!-- Title -->
                                            <template v-slot:[`item.title`]="{ item }">
                                                <BaseTooltip>
                                                    <template v-slot:content>
                                                        <div 
                                                            class='ellipsis'
                                                            :alvqa="alvqa + '-works-list-row-' + item.id + '-text-title'"
                                                        >{{ item.title }}</div></template>                            
                                                    <template v-slot:text>{{ item.title }}</template>
                                                </BaseTooltip>
                                            </template>
                                            <!-- Composers -->
                                            <template v-slot:[`item.composers`]="{ item }">
                                                <BaseTooltip>
                                                    <template v-slot:content>
                                                        <div 
                                                            class="ellipsis"
                                                            :alvqa="alvqa + '-works-list-row-' + item.id + '-text-composers'"
                                                        >{{ item.composers.join(" / ") }}</div>
                                                    </template>
                                                    <template v-slot:text>{{ item.composers.join(" / ") }}</template>
                                                </BaseTooltip>
                                            </template>
                                            <template v-slot:[`item.publishers`]="{ item }">
                                                <BaseTooltip>
                                                    <template v-slot:content>
                                                        <div 
                                                            class="ellipsis"
                                                            :alvqa="alvqa + '-works-list-row-' + item.id + '-text-publishers'"
                                                        >{{ item.publishers.join(" / ") }}</div>
                                                    </template>
                                                    <template v-slot:text>{{ item.publishers.join(" / ") }}</template>
                                                </BaseTooltip>
                                            </template>
                                            <template v-slot:[`item.gemaNumber`]="{ item }">
                                                <div :alvqa="alvqa + '-works-list-row-' + item.id + '-text-gema-number'">
                                                    {{ item.gemaNumber }}
                                                </div>
                                            </template>
                                            <template v-slot:[`item.workSheetSeconds`]="{ item }">
                                                <div :alvqa="alvqa + '-works-list-row-' + item.id + '-text-duration'">
                                                    {{ item.workSheetSeconds !== null ? $alvPlugin.transformSecondsToDuration(item.workSheetSeconds) + ' (' + (item.workSheetSeconds) + ')' : ''}}
                                                </div>
                                            </template>
                                            <template v-slot:[`item.status`]="{ item }">
                                                <div 
                                                    :alvqa="alvqa + '-works-list-row-' + item.id + '-text-status'"
                                                    class="text-right"
                                                >
                                                    {{ $t(getStatus(item.status)) }}
                                                </div>
                                            </template>
                                        </v-data-table>
                                        <!-- PAGINATION component -->
                                        <v-pagination   
                                            v-if="workPages(item) > 1"
                                            total-visible="10" 
                                            :value="currentWorkPage(item)"
                                            :length="workPages(item)"
                                            color="pagination"
                                            @input="nextWorkPage(item, $event)"
                                        ></v-pagination>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </td>
                    </template>
                </v-data-table>
                <!-- PAGINATION component -->
                <v-pagination   
                    v-if="sheetPages() > 1"
                    total-visible="10" 
                    v-model="currentSheetPage" 
                    :length="sheetPages()"
                    color="pagination"
                    @input="nextSheetPage()"
                ></v-pagination>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseTooltip from '@/components/_base/BaseTooltip'

import { DropdownPublishingWorksStatus,
         DropdownLabelReleasesProductionTypeOptions } 
    from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "PublishingProjectsReadOnly",
    components: {
        BasePanel,
        BaseButton,
        BaseTooltip
    },
    props: {
        itemId: {
            type: Number
        }
    },
    data() {
        return {
            expandedItems: [],
            alvqa: 'publishing-projects-list-row-' + this.itemId + '-read-only',
            currentSheetPage: 1,
            // Each expanded sheet paginates its own works, keyed by sheet id.
            // A single shared page (or a single shared works array) leaks the last
            // expanded sheet's state into every other open panel.
            workPageBySheetId: {}
        }
    },
    computed: {
        item() {
            let item = this.$store.getters.getExpandedPublishingProjects.find(element => element.id === this.itemId)
            return item            
        },

        listItemsSheets(){
            let items = this.item.sheets.sort((a, b) => a.sheetNumber - b.sheetNumber)
            let startIndex = (this.currentSheetPage - 1) * this.itemsPerPage
            let endIndex = startIndex + this.itemsPerPage
            if( items.length < this.itemsPerPage) { return items }
            return items.slice(startIndex, endIndex)
        }, 

        sheetsHeaders() {
            return [
                {
					text: '', 
					value: 'data-table-expand',
					align: 'center', 
					width: "48px"
				},
                {
                    text: this.$t('lang_PUBLISHING_SHEETS_CAPTION_TITLE') + ' (' + this.item.sheets.length + ')', 
                    value: 'title', 
                    align: 'left', 
                    sortable: false, 
                    class: 'text-no-wrap',
                    width: '250px',
                    alvqa: this.alvqa + '-sheets-header-title'
                },
                {
                    text: this.$t('lang_PUBLISHING_CAPTION_COMPOSERS'), 
                    value: 'composers', 
                    align: 'left', 
                    sortable: false,
                    width: '180px',
                    alvqa: this.alvqa + '-sheets-header-composers'
                },
                {
                    text: this.$t('lang_PUBLISHING_CAPTION_PUBLISHERS'), 
                    value: 'publishers', 
                    align: 'left', 
                    sortable: false,
                    alvqa: this.alvqa + '-sheets-header-publishers'
                },
                {
                    text: this.$t('lang_PUBLISHING_SHEETS_CAPTION_PRODUCTION_YEAR'), 
                    value: 'productionYear',
                    align: 'right', 
                    sortable: false,
                    width: "150px",
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-sheets-header-production-year'
                },
                {
                    text: this.$t('lang_PUBLISHING_SHEETS_CAPTION_SHEET_NUMBER'), 
                    value: 'sheetNumber', 
                    align: 'right', 
                    sortable: false,
                    width: "150px",
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-sheets-header-sheet-number'
                }
            ]
        },
        worksHeaders() {
            return [
                {
                    text: this.$t('lang_PUBLISHING_SHEETS_CAPTION_WORK_TITLE'), 
                    value: 'title', 
                    align: 'left', 
                    sortable: false,
                    class: 'text-no-wrap',
                    width: '250px',
                    alvqa: this.alvqa + '-works-header-title'
                },
                {
                    text: this.$t('lang_PUBLISHING_CAPTION_COMPOSERS'), 
                    value: 'composers', 
                    align: 'left', 
                    sortable: false, 
                    width: '180px',
                    alvqa: this.alvqa + '-works-header-composers'
                }, 
                {
                    text: this.$t('lang_PUBLISHING_CAPTION_PUBLISHERS'), 
                    value: 'publishers', 
                    align: 'left', 
                    sortable: false,
                    alvqa: this.alvqa + '-works-header-publishers'
                },
                {
                    text: this.$t('lang_PUBLISHING_WORKS_CAPTION_WORK_ID'), 
                    value: 'gemaNumber', 
                    align: 'left', 
                    sortable: false, 
                    width: "140px",
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-works-header-gema-number'
                },
                {
                    text: this.$t('lang_PUBLISHING_SHEETS_CAPTION_SECONDS'), 
                    value: 'workSheetSeconds',
                    align: 'left', 
                    sortable: false,
                    width: "120px",
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-works-header-duration'
                }, 
                {
                    text: this.$t('lang_PUBLISHING_WORKS_CAPTION_STATUS'), 
                    value: 'status', 
                    align: 'right', 
                    sortable: false, 
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-works-header-status'
                }
            ]
        },

        itemsPerPage() { return this.$store.getters.getItemsPerPage },

        showSecondCard() {
            let tvStation = this.item.tvStation !== null
            let tag = this.item.tag !== null && this.item.tag !== ''

            if(tvStation || tag) return true
            else return false
        },
    },
    methods: {
        // Expand behaviour when clicking on a row. 
        async expandItemByClick(item) {
            if(this.expandedItems.includes(item)) { // close item.
                let indexOfItem = this.expandedItems.indexOf(item)
                this.expandedItems.splice(indexOfItem, 1) 
            } else { // open item             
                this.expandedItems.push(item) 
            }
        },

        // Works of a single sheet, sliced to that sheet's own page.
        listItemsWorks(sheet) {
            let items = this.sheetWorks(sheet)
            if (items.length < this.itemsPerPage) { return items }
            let startIndex = (this.currentWorkPage(sheet) - 1) * this.itemsPerPage
            let endIndex = startIndex + this.itemsPerPage
            return items.slice(startIndex, endIndex)
        },

        sheetWorks(sheet) {
            return Array.isArray(sheet.works) ? sheet.works : []
        },

        currentWorkPage(sheet) {
            return this.workPageBySheetId[sheet.id] || 1
        },

        getStatus(dbValue) {
            return DropdownPublishingWorksStatus.find(status => {
                return status.value === dbValue
            }).text
        },

        getProductionTypeOption(value) {
            let match = DropdownLabelReleasesProductionTypeOptions.find(productionType => {
                return productionType.value === value
            })

            if(match !== undefined) return this.$t(match.text)
            else return null
        },

        workPages(sheet){
            let items = this.sheetWorks(sheet)
            if(items.length < 1) return 0
            if (items.length < this.itemsPerPage) return 0 
            return Math.ceil(items.length / this.itemsPerPage)
        },

        nextWorkPage(sheet, page){
            this.$set(this.workPageBySheetId, sheet.id, page)
            setTimeout(() => {
                // every open panel renders its own works table, scroll to this sheet's
                this.$vuetify.goTo('#worksList-' + sheet.id)
            }, 500);
        },

        sheetPages() {
            if (this.item.sheets.length < this.itemsPerPage) return 0 
            return Math.ceil(this.item.sheets.length / this.itemsPerPage)
        },

        nextSheetPage(){
            setTimeout(() => {
                this.$vuetify.goTo('#sheetsList')
            }, 500);
        }
    }
}
</script>

<style>
    .noMinWidth table {
        min-width: 0px !important;
        table-layout: fixed;
    }
</style>